import { InlineTextButton } from '@procurify/ui'
import styled from 'styled-components'

export const GuidedIntakePromoBannerCtaStyled = styled(InlineTextButton)`
  &,
  &:hover,
  &:active,
  &:focus {
    color: ${(props) => props.theme.colors.textLink};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
  }
`
